import * as MessagesConstants from './messages'
import * as ConfigConstants from './config'

export const configConstants = ConfigConstants
export const messagesConstants = MessagesConstants
